import type { ApiError } from "@/Services/Api/Models";

import { ApiErrorCodes } from "@/Modules/App/Models/Api/ApiErrorCodes";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { endTrialPeriod } from "@/Services/TherapyApi/Users";

import useAppStore from "@/Modules/App/Store";
import useSubscriptionStore from "@/Modules/Subscription/Store";

async function endTrialPeriodAH(userId: string): Promise<void> {
  const appStore = useAppStore();
  const subscriptionStore = useSubscriptionStore();

  subscriptionStore.isLoading = true;

  try {
    await endTrialPeriod(userId);
  } catch (error) {
    const apiError = error as ApiError;

    const message =
      apiError.error_code === ApiErrorCodes.CREATE_SUBSCRIPTION_ERROR
        ? `user.settings.subscription.payment.card_error.${apiError.detail}`
        : "there_was_an_error_connecting_to_the_server_please_try_again_later";

    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message,
    });
  } finally {
    subscriptionStore.isLoading = false;
  }
}

export default endTrialPeriodAH;
